"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UISubheader = _interopRequireDefault(require("UIComponents/layout/UISubheader"));

var ResultsSectionHeader = function ResultsSectionHeader(props) {
  var className = props.className,
      rest = (0, _objectWithoutProperties2.default)(props, ["className"]);
  var computedClasses = (0, _classnames.default)('p-bottom-0', className);
  return _react.default.createElement(_UISubheader.default, (0, _extends2.default)({}, rest, {
    className: computedClasses,
    headingLevel: "h4"
  }));
};

ResultsSectionHeader.propTypes = {
  className: _propTypes.default.string
};
var _default = ResultsSectionHeader;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/results/ResultsSectionHeader.js
// module id = 291
// module chunks = 209 210 211 212